import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapNullHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.length = 1;
        this.type = Types.Null;
    }
}

//# sourceMappingURL=WrapNullHelper.js.map
